import { zodResolver } from "@hookform/resolvers/zod";
import React, { useRef } from "react";
import { useForm } from "react-hook-form";
import ErrorMessage from "../../../../components/ErrorMessage";

const LatestNewsAddModal = ({ schema, create }) => {
  const modalCloseIconButton = useRef(null);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  });

  const handleAdd = (data) => {
    create(data);
    reset();
    modalCloseIconButton.current.click();
  };

  const handleModalClose = () => {
    reset();
  };
  return (
    <>
      <div className="my-4 text-right">
        <button
          type="button"
          className="add-btn"
          data-toggle="modal"
          data-target="#addNewsModal"
        >
          add news +
        </button>
        <div
          className="modal fade"
          data-backdrop="static"
          data-keyboard="false"
          id="addNewsModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-scrollable  modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Add News
                </h5>
                <button
                  ref={modalCloseIconButton}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={handleModalClose}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body p-0">
                <div className="latest-news-sign-record pt-5 mb-0">
                  <form onSubmit={handleSubmit(handleAdd)}>
                    <div className="form__div-container">
                      <div className="form__div">
                        <input
                          type="text"
                          className="form__input"
                          {...register("titleEn")}
                        />
                        <label htmlFor="" className="form__label">
                          News Title
                        </label>
                      </div>
                      {errors.titleEn && (
                        <ErrorMessage message={errors.titleEn?.message} />
                      )}
                    </div>
                    <div className="form__div-container">
                      <div className="form__div">
                        <input
                          type="url"
                          className="form__input"
                          {...register("newsLink")}
                        />
                        <label htmlFor="" className="form__label">
                          News Link
                        </label>
                      </div>
                      {errors.newsLink && (
                        <ErrorMessage message={errors.newsLink?.message} />
                      )}
                    </div>
                    <div className="mt-3 d-flex justify-content-end">
                      <button type="submit" className="save-btn ml-2">
                        Add News +
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LatestNewsAddModal;
